import { z } from 'zod';
import { avatarAcceptedMimeTypes } from './avatar';
import { companyIdSchema } from './company';

export const companyLogoAcceptedMimeTypes = avatarAcceptedMimeTypes;
export const COMPANY_LOGO_MAX_UPLOAD_BYTES = 5 * 1024 * 1024;
export const COMPANY_LOGO_MAX_SOURCE_BYTES = 15 * 1024 * 1024;
export const COMPANY_LOGO_MAX_EDGE = 1024;
export const COMPANY_LOGO_CANONICAL_CONTENT_TYPE = 'image/webp' as const;

export const companyLogoVariantSchema = z.enum(['light', 'dark'], {
  error: 'La variante de logo est invalide.',
});

export const companyLogoMimeTypeSchema = z.enum(companyLogoAcceptedMimeTypes, {
  error: 'Le format d image n est pas supporté.',
});

export const companyBrandingSchema = z.object({
  companyId: companyIdSchema,
  logo: z.url().nullable(),
  logoDark: z.url().nullable(),
});

export const companyLogoPrepareUploadSchema = z.object({
  contentType: companyLogoMimeTypeSchema,
  filename: z.string().trim().min(1, {
    error: 'Le nom de fichier est requis.',
  }).max(255, {
    error: 'Le nom de fichier est trop long.',
  }),
  variant: companyLogoVariantSchema,
});

export const companyLogoFinalizeUploadSchema = z.object({
  temporaryObjectKey: z.string().trim().min(1, {
    error: 'La clé objet temporaire est requise.',
  }).max(1024, {
    error: 'La clé objet temporaire est invalide.',
  }),
  variant: companyLogoVariantSchema,
});

export const companyLogoRemoveSchema = z.object({
  variant: companyLogoVariantSchema,
});

export const companyLogoPrepareUploadResponseSchema = z.object({
  headers: z.object({
    'Content-Type': companyLogoMimeTypeSchema,
  }),
  maxUploadBytes: z.number().int().positive(),
  method: z.literal('PUT'),
  temporaryObjectKey: z.string().min(1),
  uploadUrl: z.url(),
});

export function resolveCompanySidebarLogoUrl(input: {
  logo: string | null;
  logoDark: string | null;
  theme: 'dark' | 'light';
}): string | null {
  if (input.theme === 'dark') {
    return input.logoDark ?? input.logo;
  }
  return input.logo ?? input.logoDark;
}

export type CompanyLogoVariant = z.infer<typeof companyLogoVariantSchema>;
export type CompanyBrandingDTO = z.infer<typeof companyBrandingSchema>;
export type CompanyLogoPrepareUploadDTO = z.infer<typeof companyLogoPrepareUploadSchema>;
export type CompanyLogoFinalizeUploadDTO = z.infer<typeof companyLogoFinalizeUploadSchema>;
export type CompanyLogoRemoveDTO = z.infer<typeof companyLogoRemoveSchema>;
export type CompanyLogoPrepareUploadResponseDTO = z.infer<
  typeof companyLogoPrepareUploadResponseSchema
>;
